import { t } from '../lib/i18n';
/**
 * Momo the cat: the user-supplied original image (a little gray cat holding a heart letter, apps/desktop/resources/brand/cat-letter.png,
 * scaled down to public/mascot/cat-letter.png by apps/desktop/scripts/make-icons.mjs).
 *
 * Animation: gently bobs up and down; blinks every few seconds (occasionally a double blink). Blinking covers the image's two eyes with "eyelids" —
 * an ellipse matching the surrounding fur + a closed-eye arc, closing top-down and lifting again. Coordinates are measured on the original image (1254 square):
 * left eye center (531, 539), right eye center (845, 473), about 121×125; the face tilts about 12° to the right and the eyelids rotate with it.
 * Static when the system has "reduce motion" enabled.
 */
const EYES = [
  { cx: 531, cy: 539 },
  { cx: 845, cy: 473 },
];
const FUR = '#b9b7b8';

export function Mascot({ className = '', label }: { className?: string; label?: string }) {
  label ??= t('馍馍猫抱着一封信');
  return (
    <span className={`mascot ${className}`.trim()} role="img" aria-label={label}>
      <img src="mascot/cat-letter.png" alt="" draggable={false} />
      <svg className="mascot__lids" viewBox="0 0 1254 1254" aria-hidden>
        {EYES.map(({ cx, cy }) => (
          <g key={cx} transform={`rotate(-12 ${cx} ${cy})`}>
            <g className="mascot__lid">
              <ellipse cx={cx} cy={cy} rx={68} ry={70} fill={FUR} />
              <path d={`M${cx - 52} ${cy + 2} Q${cx} ${cy + 34} ${cx + 52} ${cy + 2}`} fill="none" stroke="#2b2a2e" strokeWidth={11} strokeLinecap="round" />
            </g>
          </g>
        ))}
      </svg>
    </span>
  );
}

/** Small title bar logo: the cat head (once the user's logo arrives, just replace public/mascot/cat-head.png). */
export function MascotMark({ className = '' }: { className?: string }) {
  return <img className={`brand-mark ${className}`.trim()} src="mascot/cat-head.png" alt="" aria-hidden draggable={false} />;
}
